import { render } from "./NewPortalNotice.vue?vue&type=template&id=5c012cdc&scoped=true"
import script from "./NewPortalNotice.vue?vue&type=script&lang=js"
export * from "./NewPortalNotice.vue?vue&type=script&lang=js"

import "./NewPortalNotice.vue?vue&type=style&index=0&id=5c012cdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c012cdc"]])

export default __exports__